import { baseApiClient as api } from '../baseService';

export const addTagTypes = ['treatment_requests'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      requestHipaaPackageRetrieve: build.query<
        RequestHipaaPackageRetrieveApiResponse,
        RequestHipaaPackageRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/`,
        }),
        providesTags: ['treatment_requests'],
      }),
      requestPackageComponentList: build.query<
        RequestPackageComponentListApiResponse,
        RequestPackageComponentListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/`,
        }),
        providesTags: ['treatment_requests'],
      }),
      requestPackageComponentCreate: build.mutation<
        RequestPackageComponentCreateApiResponse,
        RequestPackageComponentCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/`,
          method: 'POST',
          body: queryArg.createPackageComponent,
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestPackageComponentRetrieve: build.query<
        RequestPackageComponentRetrieveApiResponse,
        RequestPackageComponentRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
        }),
        providesTags: ['treatment_requests'],
      }),
      requestPackageComponentUpdate: build.mutation<
        RequestPackageComponentUpdateApiResponse,
        RequestPackageComponentUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedUpdatePackageComponent,
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestPackageComponentDelete: build.mutation<
        RequestPackageComponentDeleteApiResponse,
        RequestPackageComponentDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestPackageComponentReorder: build.mutation<
        RequestPackageComponentReorderApiResponse,
        RequestPackageComponentReorderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/reorder/`,
          method: 'POST',
          body: queryArg.reorderComponentsRequest,
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestPackageComponentSearchTemplates: build.query<
        RequestPackageComponentSearchTemplatesApiResponse,
        RequestPackageComponentSearchTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/search_templates/`,
          params: {
            category: queryArg.category,
            include_global: queryArg.includeGlobal,
            search: queryArg.search,
          },
        }),
        providesTags: ['treatment_requests'],
      }),
      requestPackageComponentValidateAll: build.mutation<
        RequestPackageComponentValidateAllApiResponse,
        RequestPackageComponentValidateAllApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/validate_all/`,
          method: 'POST',
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestHipaaPackageRetrieve2: build.query<
        RequestHipaaPackageRetrieve2ApiResponse,
        RequestHipaaPackageRetrieve2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.id}/`,
        }),
        providesTags: ['treatment_requests'],
      }),
      requestHipaaPackageCreateWithDefaults: build.mutation<
        RequestHipaaPackageCreateWithDefaultsApiResponse,
        RequestHipaaPackageCreateWithDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.id}/create_with_defaults/`,
          method: 'POST',
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestHipaaPackagePublish: build.mutation<
        RequestHipaaPackagePublishApiResponse,
        RequestHipaaPackagePublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/publish/`,
          method: 'POST',
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestHipaaPackageRender: build.mutation<
        RequestHipaaPackageRenderApiResponse,
        RequestHipaaPackageRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/render/`,
          method: 'POST',
        }),
        invalidatesTags: ['treatment_requests'],
      }),
      requestHipaaPackageUpload: build.mutation<
        RequestHipaaPackageUploadApiResponse,
        RequestHipaaPackageUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/upload/`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['treatment_requests'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type RequestHipaaPackageRetrieveApiResponse =
  /** status 200  */ HipaaPackageSchema[];
export type RequestHipaaPackageRetrieveApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentListApiResponse =
  /** status 200  */ PackageComponentSchema[];
export type RequestPackageComponentListApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentCreateApiResponse =
  /** status 201  */ PackageComponentSchema;
export type RequestPackageComponentCreateApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  createPackageComponent: CreatePackageComponent;
};
export type RequestPackageComponentRetrieveApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentRetrieveApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentUpdateApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentUpdateApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  patchedUpdatePackageComponent: UpdatePackageComponent;
};
export type RequestPackageComponentDeleteApiResponse = unknown;
export type RequestPackageComponentDeleteApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentReorderApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentReorderApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  reorderComponentsRequest: ReorderComponentsRequest;
};
export type RequestPackageComponentSearchTemplatesApiResponse =
  /** status 200  */ SearchResults;
export type RequestPackageComponentSearchTemplatesApiArg = {
  /** Filter by template category */
  category?: string;
  /** Include global templates (default: true) */
  includeGlobal?: boolean;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  /** Search term for template name/description */
  search?: string;
};
export type RequestPackageComponentValidateAllApiResponse =
  /** status 200  */ PackageValidationResponse;
export type RequestPackageComponentValidateAllApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageRetrieve2ApiResponse =
  /** status 200  */ HipaaPackageSchema;
export type RequestHipaaPackageRetrieve2ApiArg = {
  id: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageCreateWithDefaultsApiResponse =
  /** status 201  */ HipaaPackageSchema;
export type RequestHipaaPackageCreateWithDefaultsApiArg = {
  id: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackagePublishApiResponse =
  /** status 200  */ HipaaPackageSchema;
export type RequestHipaaPackagePublishApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageRenderApiResponse =
  /** status 200  */ RenderWorkflowResponse;
export type RequestHipaaPackageRenderApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageUploadApiResponse =
  /** status 201  */ HipaaPackageSchema;
export type RequestHipaaPackageUploadApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  body: {
    blob_id: string;
  };
};
export type RenderStatus =
  | 'draft'
  | 'missing_fields'
  | 'queued_for_render'
  | 'generating'
  | 'ready'
  | 'published'
  | 'error';
export type PackageSource = 'generated' | 'manually_uploaded';
export type ComponentType =
  | 'template'
  | 'global_template'
  | 'matter_blob'
  | 'static_document'
  | 'external_file'
  | 'generated_content'
  | 'merge_document'
  | 'signed_authorization_merge';
export type StaticDocumentTag =
  | 'client_id'
  | 'attorney_relationship'
  | 'reproductive_rights'
  | 'texas_affidavit';
export type MissingFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
  is_optional?: boolean;
};
export type BlobSchema = {
  id: string | string;
  name: string;
  original_filename: string | null;
  collection_id: string | string;
  collection_name: string;
  file_hash: string;
  file_size: number;
  file_extension: string | null;
  file_mime_type: string | null;
  download_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type TemplateFormat = 'PDF' | 'DOCX' | 'HTML' | 'SMS' | 'EXTERNAL';
export type TemplateCategory =
  | 'HIPAA_COVERSHEET'
  | 'HIPAA_AUTHORIZATION'
  | 'FOIA_LETTER'
  | 'LIEN_NOTICE'
  | 'RETAINER'
  | 'LOR_GENERIC'
  | 'LOR_FIRST_PARTY'
  | 'LOR_THIRD_PARTY'
  | 'LOR_HEALTH'
  | 'WELCOME_LETTER'
  | 'DROP_LETTER'
  | 'JOINT_VENTURE_NOTICE'
  | 'CLIENT_COMMUNICATION'
  | 'MEDICAL_RECORDS_REQUEST'
  | 'AFFIDAVIT'
  | 'LETTER_OF_PROTECTION'
  | 'PRESERVATION_LETTER'
  | 'PIP_DEMAND'
  | 'OTHER';
export type TemplateScope = 'GLOBAL' | 'FIRM';
export type TemplateStatus = 'ACTIVE' | 'SUPERSEDED' | 'ARCHIVED';
export type ReadTemplateSummary = {
  id: string | string;
  name: string;
  display_name?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  requires_signatures?: boolean;
  sample_render_status?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  version: number;
  version_group: string;
  created_at: string;
  modified_at: string;
};
export type PackageComponentSchema = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  id: string | string;
  package_id: string | string;
  status?: RenderStatus;
  v2_template_id?: (string | string) | null;
  blob_id?: (string | string) | null;
  static_document_tag?: StaticDocumentTag;
  signed_blob_id?: (string | string) | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  resolved_missing_fields?: string[];
  resolved_missing_field_labels?: {
    [key: string]: string;
  };
  has_manual_edits?: boolean;
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  error_message?: string | null;
  blob?: BlobSchema;
  template?: ReadTemplateSummary;
};
export type CustomUserSchema = {
  id: string | string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  is_firm_admin?: boolean;
  avatar?: string | null;
  signature?: string | null;
};
export type ContactHandleType =
  | 'PHONE'
  | 'EMAIL'
  | 'WEBSITE'
  | 'FAX'
  | 'OTHER'
  | 'MAILING_ADDRESS';
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type ContactRequestCapabilities =
  | 'RECORDS_ONLY'
  | 'BILLS_ONLY'
  | 'RECORDS_AND_BILLS';
export type AgentType =
  | 'ingest_transcript_task'
  | 'provider_finder'
  | 'artifact_digest'
  | 'treatment_researcher'
  | 'treatment_request_automation'
  | 'bland_caller'
  | 'voice_ai'
  | 'slack_task_bot'
  | 'blob_sorter'
  | 'front_app_integration'
  | 'task_generator'
  | 'coverage_extractor'
  | 'intake_converter'
  | 'airtable_sync'
  | 'system'
  | 'backfill_script'
  | 'domain_event_update_orchestrator'
  | 'loa_detector'
  | 'rainmaker'
  | 'deliverable_sync'
  | 'bpo_agent'
  | 'loa_chaser'
  | 'external_task_rule_engine'
  | 'external_task_bulk_create'
  | 'entity_sync'
  | 'case_activation';
export type ProviderContactUnitHandleSchema = {
  id: string | string;
  provider_unit_id: string | string;
  contact_handle_id: number;
  handle: ContactHandleSchema;
  is_preferred: boolean;
  voice_ai_cadence_days?: number | null;
  capabilities: ContactRequestCapabilities;
  notes?: string | null;
  created_by_id?: (string | string) | null;
  updated_by_id?: (string | string) | null;
  created_by_agent?: AgentType;
};
export type TreatmentRecordRequestChannelType =
  | 'portal'
  | 'human'
  | 'email'
  | 'fax'
  | 'mail'
  | 'phone';
export type HipaaPackageSchema = {
  id: string | string;
  request_id: string | string;
  status: RenderStatus;
  package_source: PackageSource;
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  completed_package_id?: (string | string) | null;
  download_url?: string | null;
  manually_uploaded_url?: string | null;
  components?: PackageComponentSchema[];
  error_message?: string | null;
  approved_at?: string | null;
  approved_by?: CustomUserSchema;
  uploaded_by?: CustomUserSchema;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_contact_unit_handle?: ProviderContactUnitHandleSchema;
  provider_directory_contact_point_id?: (string | string) | null;
  locked_at?: string | null;
  locked_by_submission_channel?: TreatmentRecordRequestChannelType;
  locked_by_submission_workflow_id?: string | null;
};
export type CreatePackageComponent = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  v2_template_id?: (string | string) | null;
  blob_id?: (string | string) | null;
  static_document_tag?: StaticDocumentTag;
  signed_blob_id?: (string | string) | null;
};
export type UpdatePackageComponent = {
  order?: number | null;
  overrides?: {
    [key: string]: string;
  } | null;
  resolved_missing_fields?: string[] | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  } | null;
};
export type ComponentOrderMapping = {
  component_id: string | string;
  order: number;
};
export type ReorderComponentsRequest = {
  components: ComponentOrderMapping[];
};
export type TemplateSearchResult = {
  id: string | string;
  name: string | null;
  display_name: string | null;
  description: string | null;
  template_category: string;
  template_type: string;
  is_firm_template: boolean;
  is_default?: boolean;
};
export type SearchResults = {
  results: TemplateSearchResult[];
};
export type FieldType =
  | 'TEXT'
  | 'DATE'
  | 'CHECKBOX'
  | 'IMAGE'
  | 'ARRAY'
  | 'SIGNATURE'
  | 'INITIALS';
export type FieldSource = 'MANUAL' | 'CONTEXT' | 'SIGNING';
export type ContextCategoryMeta = {
  label: string;
  binding_key?: string | null;
  entity_absent_hint?: string | null;
};
export type MatterContextFieldType =
  | 'text'
  | 'date'
  | 'number'
  | 'boolean'
  | 'datetime'
  | 'image'
  | 'array';
export type ArrayItemProperty = {
  key: string;
  type: MatterContextFieldType;
  label: string;
  required?: boolean;
};
export type PdfPosition = {
  x: number;
  y: number;
  width: number;
  height: number;
};
export type ReadTemplateField = {
  id: string | string;
  template_id: string | string;
  reference: string;
  field_type: FieldType;
  source: FieldSource;
  context_key?: string | null;
  context_category?: string | null;
  context_category_meta?: ContextCategoryMeta;
  array_item_schema?: ArrayItemProperty[] | null;
  array_item_keys?: string[] | null;
  default_value?: string | null;
  required: boolean;
  display_name?: string | null;
  pdf_page_number?: number | null;
  pdf_position?: PdfPosition;
  created_at: string;
  modified_at: string;
};
export type AnnotationFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
  current_value?: string | null;
  value_source?: string | null;
  is_missing?: boolean;
};
export type ComponentValidationResult = {
  component_id: string | string;
  is_valid: boolean;
  missing_fields_count: number;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  template_fields?: ReadTemplateField[] | null;
  annotation_fields?: AnnotationFieldInfo[] | null;
  component_type?: ComponentType;
  order?: number | null;
};
export type PackageValidationResponse = {
  status: string;
  package_id: string | string;
  total_components: number;
  valid_components: number;
  components: ComponentValidationResult[];
  matter_context?: {
    [key: string]: string | null;
  };
};
export type RenderWorkflowResponse = {
  workflow_id: string;
  status: RenderStatus;
  package_id: string | string;
};
export type ErrorResponse = {
  error: string;
  details?: {
    [key: string]: string;
  } | null;
};
export const {
  useRequestHipaaPackageRetrieveQuery,
  useRequestPackageComponentListQuery,
  useRequestPackageComponentCreateMutation,
  useRequestPackageComponentRetrieveQuery,
  useRequestPackageComponentUpdateMutation,
  useRequestPackageComponentDeleteMutation,
  useRequestPackageComponentReorderMutation,
  useRequestPackageComponentSearchTemplatesQuery,
  useRequestPackageComponentValidateAllMutation,
  useRequestHipaaPackageRetrieve2Query,
  useRequestHipaaPackageCreateWithDefaultsMutation,
  useRequestHipaaPackagePublishMutation,
  useRequestHipaaPackageRenderMutation,
  useRequestHipaaPackageUploadMutation,
} = injectedRtkApi;
